import { Trans } from '@lingui/react/macro'
import React from 'react'
import toast from 'react-hot-toast'

import useWallet from '@/hooks/useWallet'
import { formatAddress } from '@/lib/format'
import { useBridgeContext } from '@/providers/BridgeProvider'
import { useWalletContext } from '@/providers/WalletProvider'

import ProImage from './common/Image'
import { WalletIcon } from './svgr'
import { Flex } from './ui/Box'
import { Button } from './ui/Button'
import { Text } from './ui/Text'

const ConnectWallet: React.FC = () => {
  const { address, isConnected } = useWallet()
  const { tpWallet } = useWalletContext()
  const { fromChain } = useBridgeContext()

  console.log('>>>>>> fromChain: ', fromChain)
  console.log('>>>>>> tpWallet: ', tpWallet)

  if (!isConnected)
    return fromChain && tpWallet ? (
      <Button
        variant={'primary'}
        onClick={() =>
          toast.error(
            `当前钱包(${tpWallet.name})与${fromChain?.name}不匹配，点击右上角切换到${fromChain?.name}钱包进行交易。`
          )
        }
      >
        <span>
          <Trans>钱包({tpWallet?.name})不匹配</Trans>
        </span>
      </Button>
    ) : (
      <Button disabled loading variant={'primary'}>
        <span>
          <Trans>正在连接钱包...</Trans>
        </span>
      </Button>
    )

  return (
    <Flex className="items-center space-x-2">
      <Flex className="items-center justify-center space-x-1 rounded-full bg-background-fourth p-2">
        <WalletIcon className="text-text-tertiary" />
        {address && (
          <Text className="text-xs" variant={'tertiary'}>
            {formatAddress(address, 6, -6)}
          </Text>
        )}
      </Flex>
      <ProImage className="size-6 xs:size-8" type="chain" src={fromChain?.logo} />
      {/* <Menu /> */}
    </Flex>
  )
}

export default ConnectWallet
